import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = {
  START: 'Start.string',
  STOP: 'Stop.string',
};

export function StartStopButton(props) {
  const {t} = useTranslation();

  const commonClassName = 'mc_settings_startstop_button';

  const stopBtnClassName = props.disabled
    ? `${commonClassName} mc_invalidBtn--stop`
    : `${commonClassName} mc_button--stop`;

  const startBtnClassName = props.disabled
    ? `${commonClassName} mc_invalidBtn--start`
    : `${commonClassName} mc_button--start`;

  const startButtonAltText =  props.disabled ? 'Start button. Disabled.' : 'Start button. Select to spin the tubes for the set time.'

  const stopButtonAltText =  props.disabled ? 'Stop button. Disabled.' : 'Stop button. Select to seize the current microcentrifuge operation.'

  return (
    <div className='mc_settings_startstop'>
      <Button onClick={props.onClickStop} className={stopBtnClassName} aria-label={stopButtonAltText}>
        {t(TRANSLATION_KEY.STOP)}
      </Button>
      <Button onClick={props.onClickStart} className={startBtnClassName} aria-label={startButtonAltText}>
        {t(TRANSLATION_KEY.START)}
      </Button>
    </div>
  );
}

StartStopButton.propTypes = {
  /**
   * callback for when stop button is clicked
   */
  onClickStop: PropTypes.func,
  /**
   * callback for when start butto is pressed
   */
  onClickStart: PropTypes.func,
  /**
   * specifies if buttons are disabled
   */
  disabled: PropTypes.bool,
};

StartStopButton.defaultProps = {
  className: '',
};
